import {WidgetType} from "./WidgetType";
import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";

export interface DashboardViewConfiguration {
    readonly [key: number]: DashboardConfiguration;
}

export type DashboardSummaries = ReadonlyArray<DashboardSummary>;

export interface DashboardSummary {
    readonly order: number;
    readonly name: string;
}

export function BuildDashboardSummary(order: number, name: string): DashboardSummary {
    return {
        order,
        name
    };
}

export interface DashboardConfiguration {
    readonly name: string;
    readonly layout: DashboardLayoutConfiguration;
}

export enum DashboardLayout {
    ONE_LEFT_TWO_RIGHT = "ONE_LEFT_TWO_RIGHT",
    SINGLE = "SINGLE",
    TWO_BY_TWO = "TWO_BY_TWO",
    TWO_COLUMN = "TWO_COLUMN",
    TWO_LEFT_ONE_RIGHT = "TWO_LEFT_ONE_RIGHT",
    THREE_BY_TWO = "THREE_BY_TWO",
    ONE_TOP_TWO_BOTTOM = "ONE_TOP_TWO_BOTTOM",
    TWO_TOP_ONE_BOTTOM = "TWO_TOP_ONE_BOTTOM"
}

export interface DashboardLayoutConfiguration {
    readonly security: CodeAndExchange | null;
    readonly type: DashboardLayout;
    readonly widgets: LayoutWidgetConfiguration;
}

export interface LayoutWidgetConfiguration {
    readonly [key: number]: WidgetOptions;
}

export interface WidgetOptions {
    readonly linked: boolean;
    readonly type: WidgetType;
    readonly config?: any;
}

export function widgetCount(layout: DashboardLayout): number {
    switch (layout) {
        case DashboardLayout.SINGLE:
            return 1;
        case DashboardLayout.TWO_COLUMN:
            return 2;
        case DashboardLayout.ONE_LEFT_TWO_RIGHT:
        case DashboardLayout.TWO_LEFT_ONE_RIGHT:
        case DashboardLayout.ONE_TOP_TWO_BOTTOM:
        case DashboardLayout.TWO_TOP_ONE_BOTTOM:
            return 3;
        case DashboardLayout.TWO_BY_TWO:
            return 4;
        case DashboardLayout.THREE_BY_TWO:
            return 6;
    }
}

export function emptyDashboardConfiguration(name: string, layout: DashboardLayout): DashboardConfiguration {
    const layoutConfig = emptyLayoutConfig(layout);
    return {
        name,
        layout: layoutConfig
    };
}

export function emptyLayoutConfig(layout: DashboardLayout): DashboardLayoutConfiguration {
    return {
        security: null,
        type: layout,
        widgets: {}
    };
}
